import React from "react";
import classnames from "classnames";
import { FmBox } from "../FmBox";
import useStyles from "./FmShortSummary.style";

interface FmShortSummaryProps {
    label: string;
    data?: {
        title: string;
        values: any[];
        image?: any;
    }[];
    className?: string;
}

const FmShortSummary = ({ label, data, className }: FmShortSummaryProps) => {
    const classes = useStyles();
    const containerClass = classnames(classes.box_wrapper, className);

    return (
        <FmBox className={containerClass}>
            <div className={classes.container}>
                <div className={classes.header_container}>
                    <span>{label}</span>
                </div>
                <div className={classes.content}>
                    {data &&
                        data.map((item) => {
                            return (
                                <div key={item.title} className={classes.values_container}>
                                    <div className={classes.item_title}>
                                        <span>{item.title}</span>
                                    </div>
                                    <div className={classes.values}>
                                        {item &&
                                            item.values &&
                                            item.values.map((val, index) => (
                                                <div key={index} className={classes.cropData}>
                                                    <div>{val}</div>
                                                    {item.image && <img className={classes.cropImage} src={item.image} />}
                                                </div>
                                            ))}
                                    </div>
                                </div>
                            );
                        })}
                </div>
            </div>
        </FmBox>
    );
};

export default FmShortSummary;
